module.exports = __webpack_public_path__ + "static/media/img_admission_02.3ea0fc43.png";